import {
  formatCAPEVAdaptationLabel
} from "../../../activities/cape-v/capevAdaptations";
import {
  formatLanguage
} from "../../utils/catalogDisplay";
import CatalogDetailCompactChips from "./CatalogDetailCompactChips";
import {
  getInstrumentAttributeLabels,
  getInstrumentRatingScaleValues
} from "./detailUtils";

function getAvailableAdaptationLabels(instrumentMetadata) {
  const availableAdaptations =
    instrumentMetadata?.availableAdaptations;

  if (!Array.isArray(availableAdaptations)) {
    return [];
  }

  const seen = new Set();

  return availableAdaptations
    .map((value) => formatCAPEVAdaptationLabel(value) || formatLanguage(value))
    .filter((value) => {
      if (!value || seen.has(value)) {
        return false;
      }

      seen.add(value);
      return true;
    });
}

export default function CatalogEntryEvaluationApproachPanel({
  entry
}) {
  const instrumentMetadata = entry?.metadata?.instrument;
  const methodMetadata = entry?.metadata?.method;
  const instrumentName =
    instrumentMetadata?.instrument ||
    instrumentMetadata?.baseInstrument ||
    null;
  const availableAdaptations =
    getAvailableAdaptationLabels(instrumentMetadata);
  const attributeLabels =
    getInstrumentAttributeLabels(instrumentMetadata);
  const ratingScaleValues =
    getInstrumentRatingScaleValues(instrumentMetadata);
  const methodLabel =
    String(methodMetadata?.label || "").trim() || null;
  const methodDescription =
    String(methodMetadata?.description || "").trim() || null;

  const rows = [];

  if (instrumentName) {
    rows.push({
      label: "Instrument",
      values: [instrumentName]
    });
  } else if (methodLabel) {
    rows.push({
      label: "Method",
      values: [methodLabel]
    });
  }

  if (availableAdaptations.length > 0) {
    rows.push({
      label: "Available adaptations",
      values: availableAdaptations
    });
  }

  if (attributeLabels.length > 0) {
    rows.push({
      label: "Rating items",
      values: attributeLabels
    });
  }

  if (ratingScaleValues.length > 0) {
    rows.push({
      label: "Rating scale",
      values: ratingScaleValues
    });
  }

  if (rows.length === 0 && !methodDescription) {
    return null;
  }

  return (
    <section className="catalog-detail__panel catalog-detail__panel--metadata-rows">
      <h2>Evaluation approach</h2>

      {rows.length > 0 ? (
        <dl>
          {rows.map((row) => (
            <div key={row.label}>
              <dt>{row.label}</dt>
              <dd>
                <CatalogDetailCompactChips values={row.values} />
              </dd>
            </div>
          ))}
        </dl>
      ) : null}

      {methodDescription ? (
        <p>{methodDescription}</p>
      ) : null}
    </section>
  );
}
